import {FC} from 'react';
import {Stack} from '@mui/material';
import {EmployeeDTO} from 'src/types/employee';
import {employeeActionsSx} from './EmployeeActions.sx';
import {EditEmployee} from '../EditEmployee';
import {DeleteEmployee} from '../DeleteEmployee';
import {ResendRegistration} from 'src/components/users/ResendRegistration';
import {RegistrationStatusEnum} from 'src/enums/users';

interface EmployeeActionsProps {
    row: EmployeeDTO;
}

export const EmployeeActions: FC<EmployeeActionsProps> = ({row}) => {
    return (
        <Stack sx={employeeActionsSx.root}>
            {row.user.registrationStatus === RegistrationStatusEnum.PENDING_HASH && (
                <ResendRegistration row={{...row.user, chargePointId: '', canDeleteUser: false} as any}/>
            )}
            <EditEmployee row={row}/>
            <DeleteEmployee row={row}/>
        </Stack>
    );
};